import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a752fbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("NAICS Code ( "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.census.gov/naics/",
    rel: "noreferrer noopener",
    target: "_blank"
  }, " Help me find my NAICS Code "),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconService = _resolveComponent("IconService")!
  const _component_base_input = _resolveComponent("base-input")!

  return (_openBlock(), _createBlock(_component_base_input, {
    placeholder: "Enter a code",
    bind: { autocomplete: 'off' },
    errors: _ctx.$props.errors,
    value: _ctx.$props.value,
    onChange: _ctx.handleChange
  }, _createSlots({
    title: _withCtx(() => [
      _hoisted_1
    ]),
    _: 2
  }, [
    (_ctx.$props.icon)
      ? {
          name: "icon",
          fn: _withCtx(() => [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_IconService, {
              class: "base-input__icon--stroke",
              icon: "archive"
            }, null, 512), [
              [_vShow, !_ctx.title]
            ])
          ])
        }
      : undefined
  ]), 1032, ["errors", "value", "onChange"]))
}